import { useLocation, useNavigate } from "react-router-dom";

const closeSidebar = () => {
  document.getElementById("sidebar")?.classList.remove("active");
};

const SubMenuItem = ({ href, active, onClick, setRefresh, children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  const isActive =
    active !== undefined ? active : !!href && location.pathname === href;

  const handleClick = (e) => {
    e.preventDefault();
    if (onClick) {
      onClick(e);
    } else if (href) {
      navigate(href);
    }
    closeSidebar();
    setRefresh?.((r) => !r);
  };

  return (
    <li className={isActive ? "active-menu-item" : ""} onClick={handleClick}>
      <span className={isActive ? "active-submenu-item" : ""}>{children}</span>
    </li>
  );
};

export default SubMenuItem;
